import { FieldValuesType, FormValueType, SetValuesFunction } from '../../hooks/useFormValues.js';
import { NumberInput } from './NumberInput.js';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';
import { FormErrors } from './FormErrors.js';

export interface FormNumberInputProps<T, K extends keyof T> {
	id: T[K] extends number ? K : never;
	setValues: T[K] extends number ? SetValuesFunction<T> : never;
	field?: T[K] extends number ? FieldValuesType<T[K]> : never;
	label: string;
	disabled?: boolean;
	placeholder?: string;
	step?: number;
	nogap?: boolean;
	testId?: string;
	tabIndex?: number;
	places?: number;
}

export function FormNumberInput<T, K extends keyof T>({
	field,
	placeholder,
	id,
	setValues,
	nogap,
	testId,
	tabIndex,
	places,
	label,
	disabled
}: FormNumberInputProps<T, K>) {
	const width = undefined;
	return (
		<div className={styles.fieldContainer} style={{ marginBottom: nogap ? '10px' : '30px' }}>
			<div className={styles.fieldHolder} style={{ width: width || '100%' }} data-testid={testId}>
				{label && <div className={styles.label}>{label}</div>}
				<NumberInput
					disabled={disabled}
					className={styles.input}
					value={field?.value}
					onChange={(update?: number) => {
						if (update === undefined) {
							//
							setValues({ [id]: undefined } as FormValueType<T>);
						} else {
							setValues({ [id]: update } as FormValueType<T>);
						}
					}}
					placeholder={placeholder}
					tabIndex={tabIndex}
					places={places}
				/>
				<FormErrors errors={field?.errors ?? []} />
			</div>
		</div>
	);
}
